import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import OpeningTimesRow from './OpeningTimesRow';
import OpeningTimesButtons from './OpeningTimesButtons';
import LoadingOverlay from '../LoadingOverlay';

import ErrorRow from './ErrorRow';

import './DealerOpeningTimes.css';

class DealerOpeningTimes extends Component {
  handleCancel = () => {
    this.props.onResetForm();
    this.props.onCancelClick();
  };

  render() {
    const { openingTimes, isEditing, isSaving, onEditClick, errors, onSaveClick } = this.props;

    const hasErrors = Object.keys(errors).length !== 0;

    return (
      <React.Fragment>
        {isSaving && <LoadingOverlay />}
        <div className="DealerOpeningTimes">
          <table className="DealerOpeningTimes__table">
            <thead>
              <tr>
                <FormattedMessage id="day" tagName="th" />
                <FormattedMessage id="opens_at" tagName="th" />
                <th />
                <FormattedMessage id="closes_at" tagName="th" />
                <th />
              </tr>
            </thead>

            <tbody>
              {Object.keys(openingTimes).map(day => (
                <OpeningTimesRow
                  key={day}
                  day={day}
                  open={openingTimes[day].open}
                  close={openingTimes[day].close}
                  isOpen={openingTimes[day].isOpen}
                  isEditing={isEditing}
                />
              ))}

              {errors.week && <ErrorRow msg={<FormattedMessage id={errors.week} />} />}
            </tbody>
          </table>
          <OpeningTimesButtons
            isEditing={isEditing}
            onEditClick={onEditClick}
            onSaveClick={onSaveClick}
            onCancelClick={this.handleCancel}
            isSaveDisabled={hasErrors}
          />
        </div>
      </React.Fragment>
    );
  }
}
const DaySchedulePropType = PropTypes.shape({
  close: PropTypes.string.isRequired,
  open: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
}).isRequired;

const OpeningHoursPropType = PropTypes.shape({
  monday: DaySchedulePropType,
  tuesday: DaySchedulePropType,
  wednesday: DaySchedulePropType,
  thursday: DaySchedulePropType,
  friday: DaySchedulePropType,
  saturday: DaySchedulePropType,
  sunday: DaySchedulePropType,
});

DealerOpeningTimes.propTypes = {
  openingTimes: OpeningHoursPropType.isRequired,
  errors: PropTypes.object,
  onEditClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onResetForm: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  onSaveClick: PropTypes.func.isRequired,
};

DealerOpeningTimes.defaultProps = {
  errors: {},
};

export default DealerOpeningTimes;
export { OpeningHoursPropType };



// WEBPACK FOOTER //
// ../ui-components/components/DealerOpeningTimes/DealerOpeningTimes.layout.jsx